/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Camera_Location_PlacedInputs */

const vi_camera_location_placed = /** @type {(inputs: Camera_Location_PlacedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã gắn camera vào vùng trồng`)
};

/**

* @param {Camera_Location_PlacedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const camera_location_placed = /** @type {((inputs?: Camera_Location_PlacedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Camera_Location_PlacedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_camera_location_placed(inputs)
});